import React from 'react';
import Container from '@Theme/natucare/components/Container/Container';
import ArticleTile from '@Theme/natucare/components/ArticleTile/ArticleTile';
import * as styles from './GenericBlog.module.scss';
const GenericBlog = ({
  heading,
  variant,
  items
}) => {
  if (!(items !== null && items !== void 0 && items.length)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("section", {
    className: `${styles.root} ${variant ? styles[`root${variant}`] : ''}`
  }, /*#__PURE__*/React.createElement(Container, null, heading && /*#__PURE__*/React.createElement("div", {
    className: styles.rootHeading
  }, heading), /*#__PURE__*/React.createElement("div", {
    className: styles.rootCards
  }, items === null || items === void 0 ? void 0 : items.map((item, index) => /*#__PURE__*/React.createElement(ArticleTile, Object.assign({}, item, {
    key: index
  }))))));
};
export default GenericBlog;